import { lazy } from "react";
import UIDs from "../../UIDs";

const OfferingsScreen = lazy(() => import("../../screens/portal/OfferingsScreen.jsx"));
const DetailScreen    = lazy(() => import("../../screens/portal/DetailScreen.jsx"));
const RegisterScreen  = lazy(() => import("../../screens/portal/RegisterScreen.jsx"));
const PaymentScreen   = lazy(() => import("../../screens/portal/PaymentScreen.jsx"));
const MyMembershipsScreen = lazy(() => import("../../screens/admin/MyMembershipsScreen.jsx"));
const ViewMessageCenterScreen = lazy(() => import("../../screens/admin/messagecenter/ViewMcMessageScreen"));

/**
 * Public portal routes
 */
export const portalRoutes = [
    {
        path: "/offerings",
        uid: UIDs.screens.portal.offerings,
        layout: "/portal",
        element: OfferingsScreen,
        exact: true,
    },
    {
        path: "/detail/:id",
        uid: UIDs.screens.portal.detail,
        layout: "/portal",
        element: DetailScreen,
    },
    {
        path: "/register/:id",
        uid: UIDs.screens.portal.register,
        layout: "/portal",
        element: RegisterScreen,
    },
    {
        path: "/payment",
        uid: UIDs.screens.portal.payment,
        layout: "/portal",
        element: PaymentScreen,
    },
    {
        path: "/memberships",
        uid: UIDs.screens.admin.mymemberships,
        layout: "/portal",
        element: MyMembershipsScreen,
    },
    {
        path: "/viewmessagecenter",
        uid: UIDs.screens.portal.viewmessagecenter,
        layout: "/portal",
        element: ViewMessageCenterScreen,
    },
]; 
